import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import Typography from '@/components/Rain/Typography/Typography.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'
import Input from '@/components/Input.vue'
import {
    BaseCard,
    REVIEW_LINK_INPUT,
    REVIEW_LINK_CUSTOM_FIELD,
} from '@/entities/conversation'
import DropMenu from '@/pages/conversation/components/DropMenu.vue'

interface Props {
    card: BaseCard
    customFields: string[]
    errors: {}
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewLinkCardBuilder',
  props: {
    card: null,
    customFields: null,
    errors: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as { card: BaseCard, customFields: string[], errors: {} };

// admin area survey builder component


const selectedCustomField = ref(props.card.say)


const requestTitle = ref(
    'Write the review request e.g. Use the button below to copy your testimonial and take you to the Reviews page'
)
const btnTitle = ref('Enter the button label e.g. Copy Testimonial')
const titleError = ref()

onMounted(async () => {
    onUpdate()
    emit('change', {
        ...props.card,
        title: props.card.title ?? requestTitle.value,
        btnTitle: props.card.btnTitle ?? btnTitle.value,
    })
})

const updateReviewLinkOption = (event: Event) => {
    const value = (event.target as HTMLInputElement).value

    const say = ''
    const validateIt = false
    selectedCustomField.value = say
    emit('change', {
        ...props.card,
        say,
        linkType: value,
        validateIt,
    })
}

const onUpdate = (): void => {
    if (!props.card.title || props.card.title?.trim() === ' ') {
        titleError.value = 'You cannot leave this field blank'
    }

    if (!props.card.btnTitle || props.card.btnTitle?.trim() === ' ') {
        titleError.value = 'You cannot leave this field blank'
    }
}

// every keystroke will trigger data validation, will remove empty input error message.
const updateSay = (event: Event) => {
    const target = event.target as HTMLInputElement
    let say = target.value

    say = correctGoogleReviewUrl(say)
    emit('change', {
        ...props.card,
        say,
    })
}

const updateTitle = (event: Event) => {
    const target = event.target as HTMLInputElement

    emit('change', {
        ...props.card,
        title: target.value,
    })
}

const updateBtnTitle = (event: Event) => {
    const target = event.target as HTMLInputElement

    emit('change', {
        ...props.card,
        btnTitle: target.value,
    })
}

// Will trigger this when textarea lost focus. Will trigger URL validation check.
const validateSay = (event: Event) => {
    const target = event.target as HTMLInputElement
    let say = target.value

    say = correctGoogleReviewUrl(say)
    const validateIt = true
    emit('change', {
        ...props.card,
        say,
        validateIt,
    })
}

const onSelection = (customField: string) => {
    selectedCustomField.value = customField

    emit('change', {
        ...props.card,
        say: customField,
    })
}

const correctGoogleReviewUrl = (url: string): string => {
    // automatically remove space from URL entered.
    return url.replace(/[\s]/gi, '')
}

return { __sfc: true,props, selectedCustomField, emit, requestTitle, btnTitle, titleError, updateReviewLinkOption, onUpdate, updateSay, updateTitle, updateBtnTitle, validateSay, onSelection, correctGoogleReviewUrl, Typography, InfoTooltip, REVIEW_LINK_INPUT, REVIEW_LINK_CUSTOM_FIELD, DropMenu }
}

})